import React, { useRef, useEffect, useState } from 'react';
import './InputPin.css';
import OtpInput from 'react-otp-input';

const InputPin = ({serverCode, setCode}) => {

    // const [otp, setOtp] = useState('1237');

    useEffect(() => {
        document.getElementById('code-4').addEventListener('input',function(){
            document.getElementById('code-4').blur();
        });
    });

    return (
        <OtpInput
            // value={otp}
            // onChange={setOtp}
            value={serverCode}
            onChange={setCode}
            numInputs={4}
            renderSeparator={<span style={{ width: "8px" }}></span>}
            inputType={"tel"}
            shouldAutoFocus={true}
            inputStyle={{
                border: "1px solid grey",
                borderRadius: "8px",
                width: "1.5em",
                height: "1.5em",
                fontSize: "1.4em",
                color: "#000",
                fontWeight: "400",
                caretColor: "#000"
            }}
            focusStyle={{
                // border: "1px solid #CFD3DB",
                // outline: "none"
                outline: "1px solid dodgerblue",
            }}
            renderInput={(props, index) => <input id={`code-${index+1}`} {...props} />}
        />
    );
};

export default InputPin;